/* NNM signup popup - in-house replacement for the OptiMonk welcome popup.
   Reads its config from #nnm-popup-config (rendered by snippets/nnm-signup-popup.liquid).
   Flow: teaser tab -> email step -> SMS Club upsell -> thank-you.
   Email/SMS go straight to Klaviyo (client API, public company id); the existing
   Klaviyo welcome flow sends the codes. Shopify customer is created via the theme's
   standard customer form. Preview with ?nnm_popup=preview, clear state with ?nnm_popup=reset. */
(function () {
  'use strict';
  if (window.__nnmPopupInit) return;
  window.__nnmPopupInit = true;

  var cfgEl = document.getElementById('nnm-popup-config');
  var root = document.getElementById('nnm-popup-root');
  if (!cfgEl || !root) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var params = new URLSearchParams(location.search);
  var mode = params.get('nnm_popup') || '';
  var preview = mode === 'preview';
  var KEY = 'nnmPopup';
  var SKEY = 'nnmPopupSession';

  function load(k) { try { return JSON.parse((k === SKEY ? sessionStorage : localStorage).getItem(k)) || {}; } catch (e) { return {}; } }
  function save(k, v) { try { (k === SKEY ? sessionStorage : localStorage).setItem(k, JSON.stringify(v)); } catch (e) {} }
  if (mode === 'reset') { try { localStorage.removeItem(KEY); sessionStorage.removeItem(SKEY); } catch (e) {} }

  var state = load(KEY);
  var session = load(SKEY);
  var now = Date.now();

  /* ---- gating ---- */
  if (!cfg.enabled && !preview) return;
  var url = (location.pathname + location.search).toLowerCase();
  var excl = cfg.excludeUrl || [];
  for (var i = 0; i < excl.length; i++) { if (excl[i] && url.indexOf(String(excl[i]).toLowerCase()) !== -1) return; }
  if (state.converted && !preview) return;

  /* ---- variant (sticky per visitor) ---- */
  var variants = (cfg.variants && cfg.variants.length) ? cfg.variants : [{ key: 'A', weight: 1 }];
  var variant = null;
  for (var v = 0; v < variants.length; v++) { if (variants[v].key === state.variant) variant = variants[v]; }
  if (!variant) {
    var total = 0, r, acc = 0;
    for (v = 0; v < variants.length; v++) total += (variants[v].weight || 0);
    r = Math.random() * (total || 1);
    for (v = 0; v < variants.length; v++) { acc += (variants[v].weight || 0); if (r < acc) { variant = variants[v]; break; } }
    variant = variant || variants[0];
    state.variant = variant.key;
    save(KEY, state);
  }
  function applyCopy(map) {
    if (!map) return;
    Object.keys(map).forEach(function (k) {
      var els = root.querySelectorAll('[data-copy="' + k + '"]');
      for (var j = 0; j < els.length; j++) els[j].textContent = map[k];
    });
  }
  applyCopy(cfg.copy);
  applyCopy(variant.copy);
  if (cfg.teaser && typeof cfg.teaser.badge === 'string') applyCopy({ 'teaser.badge': cfg.teaser.badge });

  /* ---- elements ---- */
  var teaser = document.getElementById('nnm-teaser');
  var popup = document.getElementById('nnm-popup');
  var win = popup.querySelector('.nnm-popup__window');
  var steps = popup.querySelectorAll('.nnm-popup__step');
  var lastFocus = null;
  var isOpen = false;
  var openedBy = '';
  var email = '';
  var isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var loadedAt = now;

  root.hidden = false;

  function cssReady(cb) {
    var link = document.getElementById('nnm-popup-css');
    var done = false;
    function go() { if (!done) { done = true; cb(); } }
    if (!link || link.media === 'all' || (link.sheet && link.sheet.cssRules && link.sheet.cssRules.length)) { go(); return; }
    link.media = 'all';
    link.addEventListener('load', go, { once: true });
    setTimeout(go, 800);
  }

  function track(name, data) {
    var payload = data || {};
    payload.variant = variant.key;
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('nnm_popup_' + name, payload); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; var d = { event: 'nnm_popup_' + name }; for (var k in payload) d['popup_' + k] = payload[k]; window.dataLayer.push(d); } catch (e) {}
  }

  /* ---- steps ---- */
  function showStep(name) {
    for (var s = 0; s < steps.length; s++) steps[s].classList.toggle('is-active', steps[s].getAttribute('data-step') === name);
    var stamp = popup.querySelector('[data-stamp]');
    if (stamp) {
      var map = { email: ['?', 'Mystery discount'], sms: ['10%', 'Unlocked'], 'done-sms': ['15%', 'SMS Club'], 'done-email': ['10%', 'On its way'] };
      var m = map[name] || map.email;
      stamp.querySelector('strong').textContent = m[0];
      stamp.querySelector('span').textContent = m[1];
    }
    try { popup.querySelector('.nnm-popup__body').scrollTop = 0; } catch (e) {}
    var active = popup.querySelector('.nnm-popup__step.is-active');
    if (active && isDesktop) {
      var inp = active.querySelector('input');
      if (inp) setTimeout(function () { inp.focus(); }, 60);
    }
  }

  /* ---- open / close ---- */
  function openPopup(reason) {
    if (isOpen) return;
    cssReady(function () {
      isOpen = true;
      openedBy = reason;
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.documentElement.classList.add('nnm-popup-open');
      if (teaser) teaser.hidden = true;
      showStep(state.emailDone ? (cfg.smsStep && !state.smsDone ? 'sms' : 'done-email') : 'email');
      if (!isDesktop) setTimeout(function () { try { win.focus(); } catch (e) {} }, 60);
      if (reason !== 'teaser' && !preview) {
        state.shows = (state.shows || 0) + 1;
        state.last = Date.now();
        save(KEY, state);
      }
      track('open', { reason: reason });
    });
  }

  function closePopup(reason) {
    if (!isOpen) return;
    isOpen = false;
    popup.hidden = true;
    resetSheet();
    document.documentElement.classList.remove('nnm-popup-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    track('close', { reason: reason || 'close', step: currentStep() });
    if (!state.converted && !session.teaserClosed) showTeaser();
  }

  function currentStep() {
    var a = popup.querySelector('.nnm-popup__step.is-active');
    return a ? a.getAttribute('data-step') : '';
  }

  /* ---- swipe down to close (phone bottom sheet) ----
     A drag that starts on the green band or handle always moves the sheet; one that starts in the
     body moves it only while the sheet is scrolled to the top, and never from a field, button or
     link, so taps and typing are untouched. The inline animation:none matters: the sheet-in
     keyframes (fill: both) would otherwise override the inline transform. It stays until close so
     a snap-back does not replay the entrance; resetSheet() clears it once the popup is hidden. */
  var overlay = popup.querySelector('.nnm-popup__overlay');
  var sheetMq = window.matchMedia('(max-width: 767px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var drag = null;
  var swipeClosing = false;

  function resetSheet() {
    drag = null;
    win.style.animation = win.style.transition = win.style.transform = '';
    if (overlay) overlay.style.animation = overlay.style.transition = overlay.style.opacity = '';
  }

  function endDrag(e, allowClose) {
    var d = drag;
    drag = null;
    if (!d || !d.active) return;
    var h = win.offsetHeight || 1;
    var v = (e && e.timeStamp - d.lastT > 120) ? 0 : d.v;          /* paused before lifting = no flick */
    var close = allowClose && (d.dy > Math.min(140, h * 0.28) || (d.dy > 24 && v > 0.45));
    var ms = reduceMotion ? 0 : 220;
    win.style.transition = 'transform ' + ms + 'ms ' + (close ? 'ease-in' : 'cubic-bezier(.2, .9, .3, 1)');
    if (overlay) overlay.style.transition = 'opacity ' + ms + 'ms ease';
    if (close) {
      swipeClosing = true;
      win.style.transform = 'translateY(100%)';
      if (overlay) overlay.style.opacity = '0';
      setTimeout(function () { swipeClosing = false; closePopup('swipe'); }, ms + 20);
    } else {
      win.style.transform = 'translateY(0)';
      if (overlay) overlay.style.opacity = '1';
    }
  }

  win.addEventListener('touchstart', function (e) {
    drag = null;
    if (!isOpen || swipeClosing || !sheetMq.matches || e.touches.length !== 1) return;
    var t = e.target;
    if (t.closest && t.closest('input, textarea, select, button, a, label')) return;
    var p = e.touches[0];
    drag = {
      x: p.clientX, y: p.clientY, lastY: p.clientY, lastT: e.timeStamp, v: 0, dy: 0, active: false,
      grip: !!(t.closest && t.closest('.nnm-popup__media, .nnm-popup__handle'))
    };
  }, { passive: true });

  win.addEventListener('touchmove', function (e) {
    if (!drag) return;
    if (e.touches.length !== 1) { endDrag(e, false); return; }
    var p = e.touches[0];
    var dx = p.clientX - drag.x;
    var dy = p.clientY - drag.y;
    if (!drag.active) {
      if (!drag.grip && win.scrollTop > 0) { drag = null; return; }              /* content is scrolling */
      if (dy < -4 || Math.abs(dx) > Math.abs(dy) + 6) { drag = null; return; }   /* upward or sideways */
      if (dy > 0 && e.cancelable) e.preventDefault();                            /* keep the gesture ours */
      if (dy < 6) return;
      drag.active = true;
      win.style.animation = 'none';
      win.style.transition = 'none';
      if (overlay) { overlay.style.animation = 'none'; overlay.style.transition = 'none'; }
    }
    if (e.cancelable) e.preventDefault();
    dy = Math.max(0, dy);
    var dt = e.timeStamp - drag.lastT;
    if (dt > 0) drag.v = 0.6 * ((p.clientY - drag.lastY) / dt) + 0.4 * drag.v;
    drag.lastY = p.clientY;
    drag.lastT = e.timeStamp;
    drag.dy = dy;
    win.style.transform = 'translateY(' + Math.round(dy) + 'px)';
    if (overlay) overlay.style.opacity = String(1 - Math.min(dy / (win.offsetHeight || 1), 1) * 0.7);
  }, { passive: false });

  win.addEventListener('touchend', function (e) { endDrag(e, true); });
  win.addEventListener('touchcancel', function (e) { endDrag(e, false); });

  /* Keep the teaser clear of any theme bar pinned to the bottom of the viewport
     (mobile collection pages have a sticky "Filter & Sort" bar bottom-left). */
  function positionTeaser() {
    if (!teaser || teaser.hidden) return;
    try {
      var base = window.innerWidth < 768 ? 12 : 16;
      teaser.style.bottom = base + 'px';
      var tr = teaser.getBoundingClientRect();
      var vh = window.innerHeight;
      var lift = 0;
      if (!document.elementsFromPoint) return;
      /* Look underneath the teaser at a few points; anything fixed/sticky sitting on the
         bottom edge of the viewport there is a theme bar we must sit above. */
      var xs = [tr.left + 8, (tr.left + tr.right) / 2, tr.right - 8];
      var ys = [tr.top + 4, (tr.top + tr.bottom) / 2, tr.bottom - 4];
      var seen = [];
      for (var xi = 0; xi < xs.length; xi++) {
        for (var yi = 0; yi < ys.length; yi++) {
          var stack = document.elementsFromPoint(xs[xi], ys[yi]) || [];
          for (var i = 0; i < stack.length; i++) {
            var el = stack[i];
            if (el === teaser || teaser.contains(el) || root.contains(el) || seen.indexOf(el) !== -1) continue;
            seen.push(el);
            if (el === document.documentElement || el === document.body) continue;
            var cs = window.getComputedStyle(el);
            if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
            if (cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
            var r = el.getBoundingClientRect();
            if (r.height === 0 || r.height > vh * 0.5) continue;
            if (r.bottom < vh - 60) continue;                       /* not hugging the bottom */
            lift = Math.max(lift, vh - r.top + 10);
          }
        }
      }
      if (lift) teaser.style.bottom = Math.round(lift) + 'px';
    } catch (e) {}
  }
  var posTimer = null;
  function schedulePosition() { clearTimeout(posTimer); posTimer = setTimeout(positionTeaser, 120); }
  window.addEventListener('resize', schedulePosition);
  window.addEventListener('scroll', schedulePosition, { passive: true });

  function showTeaser() {
    if (!teaser || isOpen || session.teaserClosed || (state.converted && !preview)) return;
    cssReady(function () { teaser.hidden = false; positionTeaser(); setTimeout(positionTeaser, 400); });
  }

  /* On phones the page's own toolbar (e.g. "Filter & Sort") often sits exactly where the teaser
     lands at page load, so wait for the first small scroll (or 20 s) before showing it there. */
  function showTeaserWhenClear() {
    if (window.innerWidth >= 768 || window.scrollY >= 120) { showTeaser(); return; }
    var shown = false, iv = null;
    var go = function () { if (shown) return; shown = true; window.removeEventListener('scroll', onS); if (iv) clearInterval(iv); showTeaser(); };
    var onS = function () { if (window.scrollY >= 120) go(); };
    window.addEventListener('scroll', onS, { passive: true });
    iv = setInterval(onS, 1000);
    setTimeout(go, 20000);
  }

  function canAutoOpen() {
    if (preview) return true;
    var f = cfg.frequency || {};
    if ((state.shows || 0) >= (f.maxShows || 2)) return false;
    if (state.last && Date.now() - state.last < (f.minGapSeconds || 3600) * 1000) return false;
    if (session.autoShown) return false;
    return true;
  }

  var fired = false;
  function autoOpen(reason) {
    if (fired || isOpen) return;
    if (!canAutoOpen()) return;
    fired = true;
    session.autoShown = true;
    save(SKEY, session);
    openPopup(reason);
  }

  /* ---- triggers ---- */
  function preloadLeaf() {
    try { var leaf = popup.querySelector('.nnm-popup__leaf'); if (leaf && leaf.getAttribute('src')) { var im = new Image(); im.src = leaf.getAttribute('src'); } } catch (e) {}
  }

  function armTriggers() {
    var t = cfg.triggers || {};
    setTimeout(preloadLeaf, 1500);
    if (t.timed) setTimeout(function () { autoOpen('timed'); }, t.timed * 1000);
    if (t.scroll) {
      var pct = t.scroll / 100;
      var poll = null;
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h <= 0) return;
        if (window.scrollY / h >= pct) {
          window.removeEventListener('scroll', onScroll);
          if (poll) clearInterval(poll);
          autoOpen('scroll');
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      poll = setInterval(function () { if (fired || isOpen) { clearInterval(poll); return; } onScroll(); }, 1000);
    }
    if (t.exitIntent && isDesktop) {
      document.addEventListener('mouseout', function (e) {
        if (e.relatedTarget || e.toElement) return;
        if (e.clientY > 0) return;
        if (Date.now() - loadedAt < (t.exitMinSeconds || 5) * 1000) return;
        autoOpen('exit');
      });
    }
    var teaserDelay = (cfg.teaser && cfg.teaser.delay) || 6;
    setTimeout(showTeaserWhenClear, teaserDelay * 1000);
  }

  /* ---- Klaviyo / Shopify ---- */
  function klSubscribe(attrs) {
    var body = {
      data: {
        type: 'subscription',
        attributes: { custom_source: cfg.source || 'NNM Signup Popup', profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-07-15' },
      body: JSON.stringify(body),
      keepalive: true
    }).then(function (r) { if (!(r.status === 202 || r.ok)) throw new Error('klaviyo ' + r.status); });
  }

  function klIdentify(attrs) {
    try { if (window.klaviyo && typeof window.klaviyo.push === 'function') window.klaviyo.push(['identify', attrs]); } catch (e) {}
  }

  function shopifyCustomer(addr) {
    try {
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', addr);
      fd.append('contact[tags]', cfg.customerTags || 'prospect, newsletter, popup');
      fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin', keepalive: true }).catch(function () {});
    } catch (e) {}
  }

  function props(extra) {
    var p = { 'Popup Variant': variant.key, 'Popup Trigger': openedBy || 'unknown', 'Popup Page': location.pathname };
    if (extra) for (var k in extra) p[k] = extra[k];
    return p;
  }

  /* ---- forms ---- */
  function setBusy(form, busy) {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    btn.disabled = busy;
    btn.classList.toggle('is-busy', busy);
  }
  function setError(form, msg) {
    var el = form.querySelector('[data-error]');
    if (el) el.textContent = msg || '';
    form.classList.toggle('is-invalid', !!msg);
  }

  function validEmail(s) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s); }

  function normalisePhone(raw) {
    var s = String(raw || '').replace(/[\s\-().]/g, '');
    if (/^\+61/.test(s)) s = s.slice(3);
    else if (/^61\d{9}$/.test(s)) s = s.slice(2);
    else if (/^0\d{9}$/.test(s)) s = s.slice(1);
    if (/^[45]\d{8}$/.test(s)) return '+61' + s;
    return null;
  }

  var emailForm = popup.querySelector('[data-form="email"]');
  var smsForm = popup.querySelector('[data-form="sms"]');

  /* Enter inside an input always submits its form (belt and braces for odd mobile keyboards). */
  popup.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target || e.target.tagName !== 'INPUT') return;
    var f = e.target.closest ? e.target.closest('form') : null;
    if (!f) return;
    e.preventDefault();
    if (typeof f.requestSubmit === 'function') f.requestSubmit(); else { var b = f.querySelector('button[type="submit"]'); if (b) b.click(); }
  });

  if (emailForm) emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = emailForm.querySelector('input[type="email"]');
    var val = (input.value || '').trim();
    if (!validEmail(val)) { setError(emailForm, 'Please enter a valid email address.'); input.focus(); return; }
    setError(emailForm, '');
    setBusy(emailForm, true);
    email = val;
    klSubscribe({ email: email, properties: props(), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } })
      .then(function () {
        state.emailDone = true;
        state.converted = true;
        state.email = email;
        save(KEY, state);
        klIdentify({ $email: email });
        shopifyCustomer(email);
        track('email', { page: location.pathname });
        setBusy(emailForm, false);
        showStep(cfg.smsStep ? 'sms' : 'done-email');
      })
      .catch(function () {
        setBusy(emailForm, false);
        setError(emailForm, 'Something went wrong. Please try again.');
      });
  });

  if (smsForm) smsForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = smsForm.querySelector('input[type="tel"]');
    var phone = normalisePhone(input.value);
    if (!phone) { setError(smsForm, 'Please enter an Australian mobile number.'); input.focus(); return; }
    setError(smsForm, '');
    setBusy(smsForm, true);
    var addr = email || state.email || '';
    var attrs = { phone_number: phone, properties: props({ 'SMS Club': true }), subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } };
    if (addr) attrs.email = addr;
    klSubscribe(attrs)
      .then(function () {
        state.smsDone = true;
        save(KEY, state);
        klIdentify(addr ? { $email: addr, $phone_number: phone } : { $phone_number: phone });
        try { if (window.klaviyo && typeof window.klaviyo.push === 'function') window.klaviyo.push(['track', 'Joined SMS Club', { source: 'NNM Signup Popup', variant: variant.key }]); } catch (err) {}
        track('sms', {});
        setBusy(smsForm, false);
        showStep('done-sms');
      })
      .catch(function () {
        setBusy(smsForm, false);
        setError(smsForm, 'Something went wrong. Please try again.');
      });
  });

  /* ---- wiring ---- */
  popup.addEventListener('click', function (e) {
    var t = e.target;
    var closeBtn = t.closest ? t.closest('[data-close]') : null;
    if (closeBtn) {
      if (closeBtn.classList.contains('nnm-popup__overlay') && isDesktop) return;
      e.preventDefault();
      closePopup(closeBtn.getAttribute('data-close') || 'close');
      return;
    }
    var to = t.closest ? t.closest('[data-step-to]') : null;
    if (to) { e.preventDefault(); track('skip', { step: currentStep() }); showStep(to.getAttribute('data-step-to')); return; }
    var copy = t.closest ? t.closest('[data-copy-code]') : null;
    if (copy) {
      e.preventDefault();
      var code = copy.getAttribute('data-copy-code');
      var done = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 1800); };
      try { navigator.clipboard.writeText(code).then(done, done); } catch (err) { done(); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { closePopup('esc'); return; }
    if (e.key === 'Tab') {
      var f = win.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var list = [];
      for (var i = 0; i < f.length; i++) if (f[i].offsetParent !== null) list.push(f[i]);
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  if (teaser) {
    var tBtn = teaser.querySelector('.nnm-teaser__btn');
    var tClose = teaser.querySelector('.nnm-teaser__close');
    if (tBtn) tBtn.addEventListener('click', function () { track('teaser_click', {}); openPopup('teaser'); });
    if (tClose) tClose.addEventListener('click', function (e) {
      e.stopPropagation();
      teaser.hidden = true;
      session.teaserClosed = true;
      save(SKEY, session);
      track('teaser_close', {});
    });
  }

  /* ---- go ---- */
  function start() {
    if (preview) { setTimeout(function () { openPopup('preview'); }, 300); return; }
    if (cfg.skipIdentified && window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
      var decided = false;
      var go = function (known) { if (decided) return; decided = true; if (!known) armTriggers(); };
      try { var p = window.klaviyo.isIdentified(); if (p && p.then) { p.then(function (k) { go(!!k); }, function () { go(false); }); } else { go(!!p); } } catch (e) { go(false); }
      setTimeout(function () { go(false); }, 1500);
      return;
    }
    armTriggers();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
